import axios from "axios";
import { API_URL } from "../variables";
import { clearCart } from "../reducers/cartReducer";

export const PLACE_ORDER_REQUEST = "PLACE_ORDER_REQUEST";
export const PLACE_ORDER_SUCCESS = "PLACE_ORDER_SUCCESS";
export const PLACE_ORDER_FAILURE = "PLACE_ORDER_FAILURE";

export const GET_ORDERS_REQUEST = "GET_ORDERS_REQUEST";
export const GET_ORDERS_SUCCESS = "GET_ORDERS_SUCCESS";
export const GET_ORDERS_FAILURE = "GET_ORDERS_FAILURE";

export const UPDATE_ORDER_STATUS_REQUEST = "UPDATE_ORDER_STATUS_REQUEST";
export const UPDATE_ORDER_STATUS_SUCCESS = "UPDATE_ORDER_STATUS_SUCCESS";
export const UPDATE_ORDER_STATUS_FAILURE = "UPDATE_ORDER_STATUS_FAILURE";

export const PLACE_CUSTOM_ORDER_REQUEST = "PLACE_CUSTOM_ORDER_REQUEST";
export const PLACE_CUSTOM_ORDER_SUCCESS = "PLACE_CUSTOM_ORDER_SUCCESS";
export const PLACE_CUSTOM_ORDER_FAILURE = "PLACE_CUSTOM_ORDER_FAILURE";

export const PAYMENT_CALLBACK_REQUEST = "PAYMENT_CALLBACK_REQUEST";
export const PAYMENT_CALLBACK_SUCCESS = "PAYMENT_CALLBACK_SUCCESS";
export const PAYMENT_CALLBACK_FAILURE = "PAYMENT_CALLBACK_FAILURE";

export const PAY_ORDER_REQUEST = "PAY_ORDER_REQUEST";
export const PAY_ORDER_SUCCESS = "PAY_ORDER_SUCCESS";
export const PAY_ORDER_FAILURE = "PAY_ORDER_FAILURE";

export const placeOrder = (orderData) => async (dispatch, getState) => {
  dispatch({ type: PLACE_ORDER_REQUEST });
  const { token } = getState().auth;
  const { appliedCoupons } = getState().coupons;

  try {
    // Get referral code from localStorage with idp_prefix
    const referralCode = localStorage.getItem("idp_referralCode");

    // Include applied coupon code and referral code in order data
    const orderDataWithCoupon = {
      ...orderData,
      applied_coupon_code:
        appliedCoupons.length > 0 ? appliedCoupons[0].coupon_code : null,
      referral_code: referralCode || null,
    };

    const response = await axios.post(
      `${API_URL}/api/orders/place`,
      orderDataWithCoupon,
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    dispatch({ type: PLACE_ORDER_SUCCESS, payload: response.data });
    dispatch(clearCart());
    // Keep referral code in localStorage for future use
    // It will persist until a new referral code is provided in the URL or manually cleared
    return response.data;
  } catch (error) {
    dispatch({ type: PLACE_ORDER_FAILURE, payload: error.message });
    throw error;
  }
};
export const getOrdersByUserId = () => async (dispatch, getState) => {
  dispatch({ type: GET_ORDERS_REQUEST });

  const { user, token } = getState().auth;

  try {
    const response = await axios.post(
      `${API_URL}/api/orders/user`,
      { user_id: user.user_id },
      {
        headers: { Authorization: `${token}` },
      }
    );
    console.log("Fetched orders response:", response.data); // Add this log

    dispatch({
      type: GET_ORDERS_SUCCESS,
      payload: response.data.orders || response.data,
    });
  } catch (error) {
    console.error("Error fetching orders:", error);
    dispatch({ type: GET_ORDERS_FAILURE, payload: error.message });
  }
};
export const updateOrderStatus = (orderData) => async (dispatch, getState) => {
  dispatch({ type: UPDATE_ORDER_STATUS_REQUEST });

  const { token } = getState().auth;

  try {
    const response = await axios.post(
      `${API_URL}/api/orders/update`,
      orderData,
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    dispatch({ type: UPDATE_ORDER_STATUS_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: UPDATE_ORDER_STATUS_FAILURE, payload: error.message });
  }
};
export const PlaceCustomOrder = (orderData) => async (dispatch, getState) => {
  dispatch({ type: PLACE_CUSTOM_ORDER_REQUEST });

  const { token } = getState().auth;
  const { appliedCoupons } = getState().coupons;

  try {
    // Include applied coupon code in order data
    const orderDataWithCoupon = {
      ...orderData,
      applied_coupon_code:
        appliedCoupons.length > 0 ? appliedCoupons[0].coupon_code : null,
    };

    const response = await axios.post(
      `${API_URL}/api/orders/custom-place`,
      orderDataWithCoupon,
      {
        headers: { Authorization: `${token}` },
      }
    );
    dispatch({ type: PLACE_CUSTOM_ORDER_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: PLACE_CUSTOM_ORDER_FAILURE, payload: error.message });
    throw error;
  }
};

export const verifyPaymentCallback =
  (orderTrackingId, merchantReference) => async (dispatch) => {
    dispatch({ type: PAYMENT_CALLBACK_REQUEST });

    try {
      const response = await axios.get(
        `${API_URL}/api/orders/payment-callback`,
        {
          params: {
            OrderTrackingId: orderTrackingId,
            OrderMerchantReference: merchantReference,
          },
        }
      );

      dispatch({ type: PAYMENT_CALLBACK_SUCCESS, payload: response.data });
      return response.data;
    } catch (error) {
      dispatch({
        type: PAYMENT_CALLBACK_FAILURE,
        payload: error.response?.data?.message || error.message,
      });
      throw error;
    }
  };

export const payOrder = (orderId) => async (dispatch, getState) => {
  dispatch({ type: PAY_ORDER_REQUEST });

  const { token } = getState().auth;

  try {
    const response = await axios.post(
      `${API_URL}/api/orders/payorder`,
      { order_id: orderId },
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );

    dispatch({ type: PAY_ORDER_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "Payment initialization failed";
    dispatch({ type: PAY_ORDER_FAILURE, payload: errorMessage });
    throw error;
  }
};
